export const GiftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={133} height={132} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="#FFA977"
        d="M12.031 55.652v67.334c0 4.978 4.06 9.012 9.068 9.012h90.804c5.008 0 9.068-4.034 9.068-9.012V55.652H12.031Z"
      />
      <path
        fill="#FF8A4E"
        d="M66.499 19.74v15.962h-22.35a43.959 43.959 0 0 1-1.02-33.431A3.512 3.512 0 0 1 47.053.06a15.596 15.596 0 0 1 9.788 6.225L66.5 19.741ZM76.157 6.286A15.602 15.602 0 0 1 85.946.06a3.509 3.509 0 0 1 3.924 2.21 43.964 43.964 0 0 1-1.02 33.432H66.5V19.74l9.657-13.454Z"
      />
      <path
        fill="#FF6B26"
        d="m108.926 35.7-12.284 4.42L66.5 50.972V27.72l8.03-7.98L87.92 7.787A31.454 31.454 0 0 1 100.524.925c.254-.072.513-.136.771-.2.057-.015.114-.03.171-.042a28.723 28.723 0 0 1 .794-.186 39.241 39.241 0 0 1 1.313-.253c.068-.01.133-.023.201-.03a.22.22 0 0 1 .072-.01c2.992-.382 5.885 1.368 6.844 4.228.015.038.03.076.042.117l.069.227c.06.193.121.386.175.582.201.683.388 1.37.551 2.058a29.364 29.364 0 0 1 .213.93c.057.253.111.507.16.76.079.385.152.77.216 1.156l.068.412c.043.233.077.473.111.71.038.261.077.526.107.786.023.165.042.333.06.498.091.733.156 1.467.201 2.203a63.175 63.175 0 0 1 .042.766c.015.285.026.563.034.847.004.117.009.231.009.344a43.91 43.91 0 0 1-3.822 18.87v.002Z"
      />
      <path
        fill="#F85A19"
        d="m108.924 35.7-12.283 4.42c5.158-6.03 8.269-13.84 8.269-22.376A34.246 34.246 0 0 0 100.522.925c.255-.072.513-.136.772-.2.057-.015.113-.03.17-.042a27.897 27.897 0 0 1 1.651-.356c.216-.042.437-.079.657-.113a.23.23 0 0 1 .073-.01c2.992-.382 5.885 1.368 6.843 4.228.043.113.077.231.111.344.06.193.122.386.175.582.201.683.388 1.37.551 2.058.057.234.114.465.164.699.019.076.038.155.049.23.058.254.111.508.16.76.08.386.152.77.216 1.157.024.14.045.276.069.412.042.233.076.473.11.71.039.261.077.526.107.786.023.165.043.333.06.498.092.733.156 1.467.201 2.203a99.387 99.387 0 0 1 .043.766c.015.285.026.563.034.847.004.117.008.231.008.344a43.881 43.881 0 0 1-3.822 18.87v.002Z"
      />
      <path
        fill="#FF6B26"
        d="m66.499 27.72-8.03-7.98L45.08 7.787A31.517 31.517 0 0 0 29.429.246c-3.132-.538-6.213 1.29-7.161 4.303a43.96 43.96 0 0 0 1.806 31.153L66.5 50.972"
      />
      <path fill="#F85A19" d="M58.47 19.74h16.061v23.942h-16.06V19.74Z" />
      <path fill="#FF8A4E" d="M120.969 67.623H12.029v7.37h108.94v-7.37Z" />
      <path
        fill="#FFC89F"
        d="M119.932 35.701H13.068C8.06 35.701 4 39.736 4 44.713v13.898c0 4.977 4.06 9.012 9.068 9.012h106.864c5.008 0 9.068-4.035 9.068-9.013V44.714c0-4.977-4.06-9.012-9.068-9.012Z"
      />
      <path
        fill="#FF6B26"
        d="M52.447 35.701c-8.87 0-16.06 7.146-16.06 15.962v56.396l12.044-11.97 4.015 3.989 6.023-64.376h-6.023.001Z"
      />
      <path
        fill="#F85A19"
        d="M58.47 35.701c-3.326 0-6.023 2.68-6.023 5.986v58.391l8.03 7.981V41.687c0-3.306 2.697-5.986 6.023-5.986h-8.03ZM80.552 35.702h-8.03l16.06 64.375 8.03 7.981V51.662c0-8.816-7.19-15.962-16.06-15.962v.002Z"
      />
      <path
        fill="#FF6B26"
        d="M72.523 35.701H66.5c3.327 0 6.023 2.68 6.023 5.986v66.372l12.044-11.97 4.015 3.989V51.662c0-8.815-7.19-15.96-16.06-15.96h.001Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h132v132H.5z" />
      </clipPath>
    </defs>
  </svg>
);
